<template>
	<div>
		<div @click="openFilter" class="white-box link">
			<h3 class="box-title">CLIENTES</h3>
			<ul class="list-inline two-part">
				<li><i class="icon-people text-info"></i></li>
			</ul>
		</div>
		<!-- MODAL -->
		<div :id="modal.selector" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<loading :active="loading" :is-full-screen="true">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
						<h4 class="modal-title" id="myModalLabel">Filtro reportes de clientes</h4>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label class="control-label">{{ $tc('resources.partners.partner', 1) | ucfirst }}</label>
									<select v-model="filter.partner_id" class="form-control">
										<option value="all">Seleccionar...</option>
										<option :value="null">{{ $platform.name }}</option>
										<template v-if="partners">
											<template v-if="partners.length">
												<option v-for="partner in partners" :value="partner.id">{{ partner.name }}</option>
											</template>
										</template>
									</select>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label class="control-label">Fecha</label>
									<input
										id="daterange"
										type="text"
										class="form-control"/>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button @click="search" type="button" class="btn btn-default waves-effect">Buscar</button>
						<button type="button" class="btn btn-default waves-effect" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-filter-reports-customers'
				},

				loading: false,

				partners: null,

				filter: {
					partner_id: 'all',
					date: null,
				},

				partner: null,
			}
		},
		methods: {
			openFilter() {
				this.clearData()
				this.open()
				this.getPartners()
				this.initDate()
			},
			clearData() {
				this.filter.partner_id = 'all'
				this.filter.date = null
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getPartners() {
				this.loading = true
				this.$http.get('admin/partners')
				.then(response => {
					this.partners = response.body
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			initDate() {
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('#daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				})
			},
			search() {
				this.filter.date = $('#daterange').val()
				if(this.filter.partner_id == 'all') {
					var data = {
						date: this.filter.date
					}
				} else {
					var data = this.filter
				}
				this.$emit('setFilter', 'customers', data)
				this.close()
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/reports/views/customers/Filter.vue